module.exports = __webpack_public_path__ + "img/BE0648982458.870f839c.png";